<div class="row m-3" *ngIf="(showCommonItems$ | async) && currentItem">
    <emm-selection-panel
        [effectiveDate]="effectiveDate"
        [minDate]="minDate"
        (effectiveDateChange)="onEffectiveDateChanged($event)"
        [locale]="locale"
        [variations]="variations$ | async"
        [item]="item$ | async"
        [assignments]="(assignments$ | async)"
        [showButtons]="!(hideButtonsToggle$ | async) && isSuperAdmin"
        (localeChange)="locale = $event"
        (variationChange)="changeVariation($event)"
        (create)="openCreateVariationDialog()"
        *ngIf="!isReadOnly">
    </emm-selection-panel>

    <div class="col-12 d-flex justify-content-center">
        <div class="w-100" style="max-width: 1400px;">
            <!-- Non-readonly: 2-column layout -->
            <div class="row" *ngIf="!isReadOnly">
                <!-- Left side - Item details -->
                <div class="col-lg-8 col-md-12">
                    <mat-card class="me-lg-3">
                        <div class="d-flex flex-wrap">
                            <div>
                                <div class="info-message-container" *ngIf="!(item$ | async).migrated">
                                    <mat-icon>info</mat-icon>
                                    <span>This is not yet used in menus. Coming soon.</span>
                                </div>
                                <mat-card-header class="poc-item-detail2 p-4">
                                    <!-- Image and Content Row -->
                                    <div class="d-flex align-items-start">
                                        <div class="flex-shrink-0 me-4">
                                            <div class="detail-image" style="width: 120px; height: 120px;">
                                                <img [src]="getDisplayImage()" alt="Avatar" class="img-fluid" *ngIf="getDisplayImage(); else noImage"
                                                     style="width: 100%; height: 100%; object-fit: cover; border-radius: 8px;"/>
                                                <ng-template #noImage>
                                                    <img alt="Default logo" width="37px" height="37px"
                                                         src="https://d4gii57lvoht3.cloudfront.net/images/CFA_Circle_Logo.png">
                                                </ng-template>
                                            </div>
                                        </div>
                                        <div class="flex-grow-1 min-width-0">
                                            <mat-card-title class="text-break field-name">{{ itemName }}</mat-card-title>
                                            <mat-card-subtitle class="mt-2">
                                                <div
                                                    class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
                                                    <div class="d-flex align-items-center mb-1 mb-sm-0">
                                                        <span class="fw-bold me-2">Tag: </span>
                                                        <span class="me-2">
                                                            {{ itemTag }}
                                                        </span>
                                                        <button
                                                            mat-icon-button
                                                            size="small"
                                                            matTooltip="Copy tag"
                                                            (click)="copyTagToClipboard()">
                                                            <mat-icon>content_copy</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </mat-card-subtitle>
                                            <mat-card-subtitle class="mt-2"
                                                               *ngIf="(variation$ | async).variationLabel !== 'Base Item'">
                                                <span class="fw-bold">Variation ID: </span>{{ (variation$ | async).variationTag }}
                                            </mat-card-subtitle>
                                            <mat-card-subtitle class="mt-2 me-5 field-description" *ngIf="(variation$ | async).variationLabel !== 'Base Item'">
                                                <div class="d-flex align-items-start editable-field-container"
                                                     (mouseenter)="showVariationEditIcon = true"
                                                     (mouseleave)="showVariationEditIcon = false">
                                                    <div class="flex-grow-1">
                                                        <div class="variation-description-container">
                                                            <mat-icon class="info-icon">info</mat-icon>
                                                            <div *ngIf="hasVariationMetadata(); else noMetadata">
                                                                <div class="text-break mb-1 fw-bold">{{ (variation$ | async).variationLabel }}</div>
                                                                <div class="description-text" *ngIf="(variation$ | async).variationDescription">{{ (variation$ | async).variationDescription }}</div>
                                                            </div>
                                                            <ng-template #noMetadata>
                                                                <div class="text-muted">Please add information about how this variation will be used</div>
                                                            </ng-template>
                                                        </div>

                                                    </div>
                                                    <button mat-icon-button
                                                            class="edit-icon-button ms-2"
                                                            *ngIf="showVariationEditIcon && !(hideButtonsToggle$ | async) && isSuperAdmin"
                                                            (click)="openEditVariationDialog()"
                                                            matTooltip="Edit variation metadata">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </mat-card-subtitle>
                                        </div>
                                    </div>

                                    <!-- Class & Type Chips at Top Right -->
                                    <emm-class-type-chips [itemClassLabel]="itemClassLabel"
                                                          [itemTypeName]="itemTypeName">
                                    </emm-class-type-chips>
                                </mat-card-header>
                            </div>
                        </div>

                        <mat-divider class="mb-3"></mat-divider>
                        <mat-card-content>
                            <mat-tab-group *ngIf="attributeGroups.length > 0">
                                <mat-tab *ngFor="let group of attributeGroups" [label]="group">
                                    <div class="p-3">
                                        <div class="custom-message-container" *ngIf="(variation$ | async).overrides['disabled'] && (variation$ | async).variationLabel !== 'Base Item'">
                                            <mat-icon>warning</mat-icon>
                                            <span>This variation represents disabled {{ (item$ | async).name }} in the menu</span>
                                        </div>
                                        <div class="custom-message-container" *ngIf="isBaseItemDisabled">
                                            <mat-icon>warning</mat-icon>
                                            <span>This item is disabled by default</span>
                                        </div>
                                        <div class="error-message-container mt-3" *ngIf="showAssignmentsWarning">
                                            <mat-icon>error</mat-icon>
                                            <span>This item is not setup properly and will default to the base variation,
                                                possibly causing incorrect data configurations. Please contact Menu DNA
                                                to ensure this item has assignments.</span>
                                        </div>
                                        <form [formGroup]="form" *ngIf="formReady">
                                            <div class="form-section">
                                                <div class="form-row mb-3"
                                                     *ngFor="let attribute of getAttributesByGroup(group)">
                                                    <div class="form-label mb-2">
                                                        <div class="field-name">
                                                            {{ attribute.name }}
                                                            <span *ngIf="attribute.required"
                                                                  class="text-danger">*</span>
                                                        </div>
                                                    </div>
                                                    <div class="form-input">
                                                        <mat-form-field
                                                            *ngIf="getFormControlType(attribute) === 'input'"
                                                            appearance="outline" class="w-75">
                                                            <input matInput
                                                                   [formControlName]="attribute.jsonProperty">
                                                        </mat-form-field>

                                                        <mat-form-field
                                                            *ngIf="getFormControlType(attribute) === 'number'"
                                                            appearance="outline" class="w-75">
                                                            <input matInput type="number"
                                                                   [formControlName]="attribute.jsonProperty">
                                                        </mat-form-field>

                                                        <mat-form-field
                                                            *ngIf="getFormControlType(attribute) === 'textarea'"
                                                            appearance="outline" class="w-75">
                                                            <textarea matInput
                                                                      [formControlName]="attribute.jsonProperty"
                                                                      rows="3"></textarea>
                                                        </mat-form-field>

                                                        <mat-checkbox
                                                            *ngIf="getFormControlType(attribute) === 'checkbox'"
                                                            [formControlName]="attribute.jsonProperty">
                                                            {{ attribute.name }}
                                                        </mat-checkbox>

                                                        <mat-form-field
                                                            *ngIf="getFormControlType(attribute) === 'select'"
                                                            appearance="outline" class="w-75">
                                                            <mat-select [formControlName]="attribute.jsonProperty">
                                                                <mat-option *ngFor="let option of getAttributeOptions(attribute)"
                                                                            [value]="option.value ?? option">
                                                                    {{ option.label ?? option }}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>

                                                        <mat-form-field
                                                            *ngIf="getFormControlType(attribute) === 'multi-select'"
                                                            appearance="outline" class="w-75">
                                                            <mat-select [formControlName]="attribute.jsonProperty"
                                                                        multiple>
                                                                <mat-option *ngFor="let option of getAttributeOptions(attribute)"
                                                                            [value]="option.value ?? option">
                                                                    {{ option.label ?? option }}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                        <button mat-icon-button type="button" class="image-preview-button"
                                                                (click)="previewImage(attribute)"
                                                                matTooltip="Preview this image"
                                                                *ngIf="attribute.jsonProperty.toLowerCase().includes('image') && attribute.value">
                                                            <mat-icon>photo_frame</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </mat-tab>
                            </mat-tab-group>

                            <div *ngIf="attributeGroups.length === 0" class="text-center p-4">
                                <p>No attribute groups found. Check if item has attributes.</p>
                            </div>

                            <!-- Created and Updated Dates -->
                            <div class="text-center mt-4" *ngIf="currentItem?.createdDate || currentItem?.updatedDate">
                                <div *ngIf="currentItem?.createdDate" class="text-muted small">
                                    <span class="fw-bold">Created: </span>{{ currentItem.createdDate | date:'yyyy-MM-dd HH:mm' }}
                                </div>
                                <div *ngIf="currentItem?.updatedDate" class="text-muted small">
                                    <span class="fw-bold">Updated: </span>{{ currentItem.updatedDate | date:'yyyy-MM-dd HH:mm' }}
                                </div>
                            </div>
                        </mat-card-content>

                        <!-- Fixed Footer for Save Button -->
                        <div class="fixed-footer" *ngIf="!(hideButtonsToggle$ | async) && isSuperAdmin">
                            <button mat-raised-button color="primary" type="button"
                                    (click)="save()"
                                    [disabled]="form.pristine">
                                <mat-icon class="me-1 save-btn-icon">save</mat-icon>
                                Save
                            </button>
                        </div>
                    </mat-card>
                </div>

                <!-- Right side - Single column containing Components, Overrides, and Assignments -->
                <div class="col-lg-4 col-md-12">
                    <!-- Components Card -->
                    <emm-components-card
                        *ngIf="componentCardLabel"
                        [componentCardLabel]="componentCardLabel"
                        [components]="components$ | async"
                        [variation]="variation$ | async"
                        [itemName]="itemName"
                        [isReadOnly]="false"
                        [hideButtons]="hideButtonsToggle$ | async"
                        [isSuperAdmin]="isSuperAdmin"
                        [isItem]="isItem"
                        [isItemGrouping]="isItemGrouping"
                        [isModifierGrouping]="isModifierGrouping"
                        (addComponent)="openAddComponentDialog()"
                        (viewComponent)="goToComponentDetail($event)">
                    </emm-components-card>

                    <!-- Overrides for non-readonly -->
                    <emm-overrides-card
                        [variation]="variation$ | async"
                        [overridesLength]="overridesLength$ | async"
                        [hasComponentOverrides]="hasComponentOverrides$ | async"
                        [item]="item$ | async">
                    </emm-overrides-card>
                    <!-- End Overrides -->

                    <!-- Context Assignments for non-readonly -->
                    <emm-assignments-card
                        [variation]="variation$ | async"
                        [assignments]="assignments$ | async"
                        [itemTag]="itemTag"
                        [hideButtons]="hideButtonsToggle$ | async"
                        [isSuperAdmin]="isSuperAdmin"
                        (createAssignment)="openCreateAssignmentDialog()"
                        (editAssignment)="openEditAssignmentDialog($event)">
                    </emm-assignments-card>
                </div>
            </div>

            <!-- Readonly: Stacked layout -->
            <div *ngIf="isReadOnly" class="readonly-width">
                <!-- Item details - Full width when readonly -->
                <div class="row">
                    <div class="col-12">
                        <mat-card class="mb-3">
                            <div class="d-flex flex-wrap">
                                <div>
                                    <mat-card-header class="poc-item-detail2 p-4">
                                        <!-- Image and Content Row -->
                                        <div class="d-flex align-items-start">
                                            <div class="flex-shrink-0 me-4">
                                                <div class="detail-image" style="width: 120px; height: 120px;">
                                                    <img [src]="getDisplayImage()" alt="Avatar" class="img-fluid" *ngIf="getDisplayImage(); else noImage"
                                                         style="width: 100%; height: 100%; object-fit: cover; border-radius: 8px;"/>
                                                    <ng-template #noImage>
                                                        <img alt="Default logo" width="37px" height="37px"
                                                             src="https://d4gii57lvoht3.cloudfront.net/images/CFA_Circle_Logo.png">
                                                    </ng-template>
                                                </div>
                                            </div>
                                            <div class="flex-grow-1 min-width-0">
                                                <mat-card-title class="text-truncate">{{ itemName }}</mat-card-title>
                                                <mat-card-subtitle class="mt-2">
                                                    <div
                                                        class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
                                                        <div class="d-flex align-items-center mb-1 mb-sm-0">
                                                            <span class="fw-bold me-2">Tag: </span>
                                                            <span class="me-2">
                                                            {{ itemTag }}
                                                        </span>
                                                            <button
                                                                mat-icon-button
                                                                size="small"
                                                                matTooltip="Copy tag"
                                                                (click)="copyTagToClipboard()">
                                                                <mat-icon>content_copy</mat-icon>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </mat-card-subtitle>
                                                <mat-card-subtitle class="mt-2 me-5 field-description">
                                                    <div class="text-break">{{ itemDescription }}</div>
                                                </mat-card-subtitle>
                                            </div>
                                        </div>
                                    </mat-card-header>
                                </div>
                            </div>

                            <mat-divider class="mb-3"></mat-divider>
                            <mat-card-content>
                                <mat-tab-group *ngIf="attributeGroups.length > 0">
                                    <mat-tab *ngFor="let group of attributeGroups" [label]="group">
                                        <div class="p-3">
                                            <form [formGroup]="form" *ngIf="formReady">
                                                <div class="form-section">
                                                    <div class="form-row mb-3"
                                                         *ngFor="let attribute of getAttributesByGroup(group)">
                                                        <div class="form-label mb-2">
                                                            <div class="field-name">
                                                                {{ attribute.name }}
                                                                <span *ngIf="attribute.required"
                                                                      class="text-danger">*</span>
                                                            </div>
                                                        </div>
                                                        <hr>
                                                        <div class="form-input">
                                                            <mat-form-field
                                                                *ngIf="getFormControlType(attribute) === 'input'"
                                                                appearance="outline" class="w-75">
                                                                <input matInput
                                                                       [formControlName]="attribute.jsonProperty">
                                                            </mat-form-field>

                                                            <mat-form-field
                                                                *ngIf="getFormControlType(attribute) === 'number'"
                                                                appearance="outline" class="w-75">
                                                                <input matInput type="number"
                                                                       [formControlName]="attribute.jsonProperty">
                                                            </mat-form-field>

                                                            <mat-form-field
                                                                *ngIf="getFormControlType(attribute) === 'textarea'"
                                                                appearance="outline" class="w-75">
                                                                <textarea matInput
                                                                          [formControlName]="attribute.jsonProperty"
                                                                          rows="3"></textarea>
                                                            </mat-form-field>

                                                            <mat-checkbox
                                                                *ngIf="getFormControlType(attribute) === 'checkbox'"
                                                                [formControlName]="attribute.jsonProperty">
                                                                {{ attribute.name }}
                                                            </mat-checkbox>

                                                            <mat-form-field
                                                                *ngIf="getFormControlType(attribute) === 'select'"
                                                                appearance="outline" class="w-75">
                                                                <mat-select [formControlName]="attribute.jsonProperty">
                                                                    <mat-option *ngFor="let option of getAttributeOptions(attribute)"
                                                                                [value]="option.value ?? option">
                                                                        {{ option.label ?? option }}
                                                                    </mat-option>
                                                                </mat-select>
                                                            </mat-form-field>

                                                            <mat-form-field
                                                                *ngIf="getFormControlType(attribute) === 'multi-select'"
                                                                appearance="outline" class="w-75">
                                                                <mat-select [formControlName]="attribute.jsonProperty"
                                                                            multiple>
                                                                    <mat-option *ngFor="let option of getAttributeOptions(attribute)"
                                                                                [value]="option.value ?? option">
                                                                        {{ option.label ?? option }}
                                                                    </mat-option>
                                                                </mat-select>
                                                            </mat-form-field>
                                                            <button mat-icon-button type="button" class="image-preview-button"
                                                                    (click)="previewImage(attribute)"
                                                                    matTooltip="Preview this image"
                                                                    *ngIf="attribute.jsonProperty.toLowerCase().includes('image') && attribute.value">
                                                                <mat-icon>photo_frame</mat-icon>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </mat-tab>
                                </mat-tab-group>

                                <div *ngIf="attributeGroups.length === 0" class="text-center p-4">
                                    <p>No attribute groups found. Check if item has attributes.</p>
                                </div>

                                <!-- Created and Updated Dates -->
                                <div class="text-center mt-4 mb-3" *ngIf="currentItem?.createdDate || currentItem?.updatedDate">
                                    <div *ngIf="currentItem?.createdDate" class="text-muted small">
                                        Created: {{ currentItem.createdDate | date:'yyyy-MM-dd HH:mm' }}
                                    </div>
                                    <div *ngIf="currentItem?.updatedDate" class="text-muted small">
                                        Updated: {{ currentItem.updatedDate | date:'yyyy-MM-dd HH:mm' }}
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>

                <!-- Components - Stacked when readonly -->
                <div class="row">
                    <div class="col-12">
                        <emm-components-card
                            *ngIf="componentCardLabel"
                            [componentCardLabel]="componentCardLabel"
                            [components]="components$ | async"
                            [variation]="variation$ | async"
                            [itemName]="itemName"
                            [isReadOnly]="true">
                        </emm-components-card>
                    </div>
                </div>
            </div>
            <br/>
            <br/>
            <br/>
            <br/>
        </div>
    </div>
    <emm-help-button></emm-help-button>
</div>
